<template>
    <properties-block v-bind="$props" v-on="$listeners">
        <sidebar-group title="List|Liste">
            <b-form-group label-cols="4">
                <template #label>
                    <span v-tr>Spacing|Espacement</span>
                    <btn-responsive-prop v-model="block" field="spacing"/>
                </template>
                <b-select v-model="block.mediaProxy.spacing">
                    <option value="0" v-tr>None|Sans</option>
                    <option v-for="n in 100" :key="`width-${n}`" :value="`${n}px`">{{n}}px</option>
                </b-select>
            </b-form-group>
        </sidebar-group>
        <properties-component-border title="Divider|Séparateur" v-model="block.divider" v-bind="componentProps"/>
    </properties-block>
</template>

<script>
import PropertiesBlock from "@/components/editor/properties/blocks/properties-block.vue";
import BtnResponsiveProp from "../components/btn-responsive-prop.vue";
import PropertiesComponentBorder from "../components/properties-component-border.vue";
import SidebarGroup from "../components/sidebar-group.vue";

// properties-block-faq-list #hot-reload-debug
export default {
    name: `properties-block-faq-list`,
    components: {SidebarGroup, BtnResponsiveProp, PropertiesComponentBorder, PropertiesBlock},
    extends: PropertiesBlock
}
</script>

<style lang="scss" scoped>
</style>
